import 'jquery';
import isTouchDev from './isTouchDev';

export default () => {

    let pagesArr = [];
    let pagesWrapper = $('.js-pages-wrapper');
    let btnMore = $('.js-more-pages');
    let btnLess = $('.js-less-pages');

    $('.js-pages-wrapper .js-museum-box-item').each((i, item) => {
        pagesArr.push(item);
    });

    pagesWrapper.empty();

    for(let i = 0; i < 8; i++) {
        pagesWrapper.append(pagesArr[i]);
    }

    $(document).on('click', '.js-more-pages', () => {
        let currentLength = $('.js-pages-wrapper .js-museum-box-item').length;
        let newLength = currentLength + 8;

        for(let i = currentLength; i < newLength; i++) {
            pagesWrapper.append(pagesArr[i]);
        }

        if(pagesArr.length <= newLength) {
            btnLess.show();
            btnMore.hide();
        }
    });

    $(document).on('click', '.js-less-pages', () => {
        let sectionStart = $('.museum-box');

        pagesWrapper.empty();

        for(let i = 0; i < 8; i++) {
            pagesWrapper.append(pagesArr[i]);
        }

        $('html, body').animate({scrollTop:sectionStart.offset().top}, 500);

        btnLess.hide();
        btnMore.show();
    });

    $(document).ready(function() {
        let wWidth = $(window).width();
        let mapBannerHeight = $('.map-wrapper .left-section').height();
        let topBannersHeight = $('.slider-section .right-banners').height();

        if(wWidth > 1200 && wWidth < 1440) {
            $('.slider-section .right-banners').css('height', 'auto');
            setTimeout(function () {
                $('.slider-section .right-banners').css('height', 'calc(100vh - 66px)');
            }, 100);
        }

        if(wWidth <= 1200 && wWidth >= 480) {
            $('.slider-section .right-banners').css('height', 'auto');
            topBannersHeight = $('.slider-section .right-banners').height();
            setTimeout(function () {
                $('.slider-section .right-banners').css('height', topBannersHeight);
            }, 100);
        }

        if(wWidth > 1024) {
            $('.map-wrapper .left-section').css('height', 'auto');
            mapBannerHeight = $('.map-wrapper .left-section').height();

            setTimeout(function () {
                $('.map-wrapper .js-home-map-section-wrapper').css('height', mapBannerHeight);
            }, 100);
        }

        if(wWidth <= 1024 && wWidth > 768) {
            $('.map-wrapper .left-section').css('height', 'auto');
            mapBannerHeight = $('.map-wrapper .left-section').height();

            setTimeout(function () {
                $('.map-wrapper .left-section').css('height', mapBannerHeight);
            }, 100);
        }

        function onResize() {
            wWidth = $(window).width();

            if(wWidth >= 1440) {
                $('.slider-section .right-banners').css('height', 'auto');
                setTimeout(function () {
                    $('.slider-section .right-banners').css('height', '700');
                }, 100);
            }

            if(wWidth > 1200 && wWidth < 1440) {
                $('.slider-section .right-banners').css('height', 'auto');
                setTimeout(function () {
                    $('.slider-section .right-banners').css('height', 'calc(100vh - 66px)');
                }, 100);
            }

            if(wWidth <= 1200 && wWidth >= 480) {
                $('.slider-section .right-banners').css('height', 'auto');
                topBannersHeight = $('.slider-section .right-banners').height();
                setTimeout(function () {
                    $('.slider-section .right-banners').css('height', topBannersHeight);
                }, 100);
            }

            if(wWidth > 1024) {
                $('.map-wrapper .left-section').css('height', 'auto');
                mapBannerHeight = $('.map-wrapper .left-section').height();
                setTimeout(function () {
                    $('.map-wrapper .js-home-map-section-wrapper').css('height', mapBannerHeight);
                }, 100);
            }

            if(wWidth <= 1024 && wWidth > 768) {
                $('.map-wrapper .left-section').css('height', 'auto');
                mapBannerHeight = $('.map-wrapper .left-section').height();

                setTimeout(function () {
                    $('.map-wrapper .left-section').css('height', mapBannerHeight);
                }, 100);
            }

            if(isTouchDev() && wWidth <= 768) {
                $('#map').remove();
                $('.middle-banner').after(mapClone);
                $('.middle-banner').css('margin-bottom', '18px');
                $('.left-section').css('margin-bottom', '0');
            }

            if(isTouchDev() && wWidth > 768) {
                $('#map').remove();
                $('.left-section').after(mapClone);
                setTimeout(function () {
                    $('.map-wrapper .left-section').css('height', 'auto');
                    mapBannerHeight = $('.map-wrapper .left-section').height();
                    $('.map-wrapper .left-section').css('height', mapBannerHeight);
                }, 100);
                $('.middle-banner').css('margin-bottom', '0');
                $('.left-section').css('margin-bottom', '18px');
            }
        }

        $(window).resize(function () {
            onResize();
        });

        let mapClone = $('#map');

        if(isTouchDev() && wWidth <= 768) {
            $('#map').remove();
            $('.middle-banner').after(mapClone);
            $('.middle-banner').css('margin-bottom', '18px');
            $('.left-section').css('margin-bottom', '0');
        }

        let allWorkersTab = $('.personal-page .nav-tabs').find('.tab-16');
        let allWorkersContent = $('.personal-page .tab-content').find('.tab-16');

        $('.personal-page .nav-tabs li').find('a').removeClass('active');
        $('.personal-page .tab-content > div').removeClass('active');

        $('.personal-page .nav-tabs').prepend(allWorkersTab);
        $('.personal-page .tab-content').prepend(allWorkersContent);

        $('.personal-page .nav-tabs li:first-child').find('a').addClass('active');
        $('.personal-page .tab-content > div:first-child').addClass('active');



        $('.one-type .audio-box .item').each((i, item) => {
            if(i % 2 == 0) {
                $('.audio-box .right-col').append(item);
            } else {
                $('.audio-box .left-col').append(item);
            }
        });


        $('.talande-webb a').attr('id', 'bapluslogo');
        $('.talande-webb a').attr('onclick', 'toggleBar();');

    });

};


// WEBPACK FOOTER //
// ./scripts/modules/loadPages.js